const anchors = [...document.querySelectorAll('[data-anchor-item]')];
const sections = anchors
  .map(a => document.querySelector(a.getAttribute('href')))
  .filter(Boolean);

anchors[0]?.classList.add('anchor-active');

let activeId = sections[0]?.id;

const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;

      activeId = entry.target.id;

      anchors.forEach(a => {
        a.classList.toggle(
          'anchor-active',
          a.getAttribute('href') === `#${activeId}`
        );
      });
    });
  },
  {
    rootMargin: '-30% 0px -60% 0px',
    threshold: 0
  }
);

const firstAnchor = anchors[0];

window.addEventListener('scroll', () => {
  if (window.scrollY === 0) {
    activeId = sections[0]?.id;

    anchors.forEach(a => a.classList.remove('anchor-active'));
    firstAnchor?.classList.add('anchor-active');
  }
});


sections.forEach(section => observer.observe(section));
